<player-sheet #sheet (hidden)="hideSheet()">
  <div class="z-funnel-container z-fx-col z-fx-center-stretch">
    <zef-funnel-two
      *ngIf="ss.showFunnelTwo | async"
      [answers]="ss.answers | async"
      (submit)="submitFunnelTwo($event)"
    ></zef-funnel-two>
  </div>
</player-sheet>
